
























































import { Component, Vue, Prop } from "vue-property-decorator";
import DropdownAnswer from "./answer-dropdown.vue";
import NumberAnswer from "./answer-number.vue";
import { METHODS } from "http";
import { IQuestion } from "../store/main.interfaces";

@Component({
  components: { DropdownAnswer, NumberAnswer }
})
export default class QuestionAnswer extends Vue {
  @Prop() questionItem!: IQuestion;
  data() {
    return {
      dialog: false
    };
  }
}
